import { useEffect } from "react";
import { useNotificationStore } from "../../../stores/notificationStore";

export const useBackgroundNotificationListener = () => {
    const addNotification = useNotificationStore((state) => state.addNotification);

    useEffect(() => {
        if (!("serviceWorker" in navigator)) return;

        const handler = (event: MessageEvent) => {
            const { type, payload } = event.data || {};
            if (type === "NEW_NOTIFICATION" && payload) {
                addNotification(payload);
            }
        };

        navigator.serviceWorker.addEventListener("message", handler);

        return () => {
            navigator.serviceWorker.removeEventListener("message", handler);
        };
    }, [addNotification]);
};
